import type { Schemas } from "#shopware"
import { useRuntimeConfig } from "#app"
import { useI18n } from "#imports"


export const useShoeSizeMe = function () {
    const config = useRuntimeConfig().public
    const shoeSizeGroupId = config.shoeSizeVariantOptionId

    const { locale } = useI18n()
    const scriptElId = 'shoesizeme-script'

    async function initShoeSizeMe (product: Schemas['Product'], parentId: string) {
        const scriptEl = document.getElementById(scriptElId)

        if (!scriptEl) {
            window.ShoeSizeMe_loader = {
                settingParams: {
                    shopID: '64006731',
                    locale: locale?.value ? locale.value : 'de',
                    zeroHash: '',
                    scale: 'eu',
                    kids: product?.customFields?.gender === 'children',
                    targetGender: product?.customFields?.gender ?? ''
                }
            }

            const script = document.createElement('script')
            script.id = 'shoesizeme-script'
            script.src = 'https://shoesize.me/assets/plugin/loader.js'
            script.type = "text/javascript"
            document.body.appendChild(script)
        } else {
            window?.ShoeSizeMe_loader?.rebuildAllButton?.(parentId)
        }
    }

    function parseShoeSizeOptionNames (options: Schemas['PropertyGroupOption'][]) {
        return options.map(option => {
            return option?.name?.replace(',', '.')
        }).join(',')
    }

    return {
        shoeSizeGroupId,
        initShoeSizeMe,
        parseShoeSizeOptionNames
    }
}
